import React from "react";
import { TitleText, LabelText } from "../../../ui/Text";
import { FinanceIcon } from "../../../assets/svg/FinanceIcon";
import styled from "styled-components";
import { ObjectiveItem } from "./ObjectiveItem";
import { get } from "../../../utils/get";

interface IProps {
  setPrimaryObjectiveID?: any;
  data: any;
}

export const CauseEffectSection = ({ data, setPrimaryObjectiveID }: IProps) => {
  return (
    <CauseSettingsContainer>
      <CauseHeader>
        <TitleText>Cause & Effect settings</TitleText>
      </CauseHeader>
      <CausSettingsBody>
        {data.map((objective, index) => (
          <ObjectiveItem
            onClick={() =>
              setPrimaryObjectiveID(get(objective, "objective_id"))
            }
            key={index}
            to={get(objective, "id")}
            label={get(objective, "objective_name")}
            title={get(objective, "objective.perspective_name")}
          />
        ))}
      </CausSettingsBody>
    </CauseSettingsContainer>
  );
};

const CauseSettingsContainer = styled.div`
  display: grid;
  grid-template-rows: 4em auto;
  border-bottom: 1px solid #ebeeff;
  ${TitleText} {
    display: flex;
    height: 100%;
    padding: 0 2em;
    align-self: center;
  }
`;

const CauseHeader = styled.div`
  border-bottom: 1px solid #ebeeff;
  width: 101%;
`;

const CausSettingsBody = styled.div`
  height: 100%;
  width: 100%;
  /* padding: 0 2em; */
`;
